import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const BritishVirginIslandsFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16256'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16256)'>
				<rect
					width='20'
					height='14'
					fill='#07319C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M12.3809 6.99994C12.3809 6.37936 12.3809 5.66709 12.3809 5.06635C12.3809 4.32997 12.9778 3.73328 13.7142 3.73328H15.8094C16.5458 3.73328 17.1428 4.32997 17.1428 5.06635C17.1428 5.66709 17.1428 6.37936 17.1428 6.99994C17.1428 9.33328 14.7618 10.2666 14.7618 10.2666C14.7618 10.2666 12.3809 9.33328 12.3809 6.99994Z'
					fill='#008339'
				/>
				<mask
					id='mask1_2332_16256'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='12'
					y='3'
					width='6'
					height='8'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M12.3809 6.99994C12.3809 6.37936 12.3809 5.66709 12.3809 5.06635C12.3809 4.32997 12.9778 3.73328 13.7142 3.73328H15.8094C16.5458 3.73328 17.1428 4.32997 17.1428 5.06635C17.1428 5.66709 17.1428 6.37936 17.1428 6.99994C17.1428 9.33328 14.7618 10.2666 14.7618 10.2666C14.7618 10.2666 12.3809 9.33328 12.3809 6.99994Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_16256)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M13.8102 5.59996C14.0732 5.59996 14.2864 5.39103 14.2864 5.13329C14.2864 4.87556 14.0732 4.66663 13.8102 4.66663C13.5472 4.66663 13.334 4.87556 13.334 5.13329C13.334 5.39103 13.5472 5.59996 13.8102 5.59996ZM13.8102 6.53329C14.0732 6.53329 14.2864 6.32436 14.2864 6.06663C14.2864 5.80889 14.0732 5.59996 13.8102 5.59996C13.5472 5.59996 13.334 5.80889 13.334 6.06663C13.334 6.32436 13.5472 6.53329 13.8102 6.53329ZM13.8102 7.46663C13.5472 7.46663 13.334 7.25769 13.334 6.99996C13.334 6.74223 13.5472 6.53329 13.8102 6.53329C14.0732 6.53329 14.2864 6.74223 14.2864 6.99996C14.2864 7.25769 14.0732 7.46663 13.8102 7.46663ZM13.8102 7.46663C13.5472 7.46663 13.334 7.67556 13.334 7.93329C13.334 8.19103 13.5472 8.39996 13.8102 8.39996C14.0732 8.39996 14.2864 8.19103 14.2864 7.93329C14.2864 7.67556 14.0732 7.46663 13.8102 7.46663ZM16.1911 7.93329C16.1911 8.19103 15.9779 8.39996 15.7149 8.39996C15.4519 8.39996 15.2387 8.19103 15.2387 7.93329C15.2387 7.67556 15.4519 7.46663 15.7149 7.46663C15.4519 7.46663 15.2387 7.25769 15.2387 6.99996C15.2387 6.74223 15.4519 6.53329 15.7149 6.53329C15.9779 6.53329 16.1911 6.74223 16.1911 6.99996C16.1911 7.25768 15.978 7.46661 15.715 7.46663C15.978 7.46665 16.1911 7.67557 16.1911 7.93329ZM15.7149 5.59996C15.9779 5.59996 16.1911 5.39103 16.1911 5.13329C16.1911 4.87556 15.9779 4.66663 15.7149 4.66663C15.4519 4.66663 15.2387 4.87556 15.2387 5.13329C15.2387 5.39103 15.4519 5.59996 15.7149 5.59996ZM15.7149 5.59996C15.4519 5.59996 15.2387 5.80889 15.2387 6.06663C15.2387 6.32436 15.4519 6.53329 15.7149 6.53329C15.9779 6.53329 16.1911 6.32436 16.1911 6.06663C16.1911 5.80889 15.9779 5.59996 15.7149 5.59996Z'
						fill='#FFD033'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M14.7613 7.9333C15.0243 7.9333 15.2375 7.3065 15.2375 6.5333C15.2375 5.7601 15.0243 5.1333 14.7613 5.1333C14.4984 5.1333 14.2852 5.7601 14.2852 6.5333C14.2852 7.3065 14.4984 7.9333 14.7613 7.9333Z'
						fill='white'
					/>
				</g>
				<path
					d='M11.9043 9.33337C11.9043 10.2234 13.2052 10.7334 14.7614 10.7334C16.3177 10.7334 17.6186 10.2234 17.6186 9.33337C17.6186 9.07563 17.4054 8.8667 17.1424 8.8667C16.8794 8.8667 16.6662 9.07563 16.6662 9.33337C16.6662 9.34229 16.5508 9.44926 16.2682 9.56004C15.8845 9.71043 15.3441 9.80003 14.7614 9.80003C14.1788 9.80003 13.6383 9.71043 13.2547 9.56004C12.9721 9.44926 12.8567 9.34229 12.8567 9.33337C12.8567 9.07563 12.6435 8.8667 12.3805 8.8667C12.1175 8.8667 11.9043 9.07563 11.9043 9.33337Z'
					fill='#FFD033'
				/>
				<path
					d='M-0.915074 -0.333333H0H0.47619H0.581265L0.667345 -0.273077L3.9146 2H4.66793L8.39732 -0.284251L8.90476 -0.595057V0V0.293115C8.90476 0.510658 8.79862 0.714517 8.6204 0.839269L5.57143 2.97355V3.578L8.45876 6.00336C8.80818 6.29688 8.60063 6.86667 8.14428 6.86667C8.04397 6.86667 7.94608 6.83581 7.8639 6.77828M-0.915074 -0.333333L7.8639 6.77828M-0.915074 -0.333333L-0.214397 0.255235L3 2.95533V3.55978L-0.191154 5.79359L-0.333333 5.89311V6.06667V6.53333V7.12839L0.174104 6.81758L3.90349 4.53333H4.65683L7.8639 6.77828M-0.915074 -0.333333L7.8639 6.77828'
					fill='#DB1E36'
					stroke='white'
					strokeWidth='0.666667'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.33333V4.2H3.33333V6.33333C3.33333 6.70152 3.63181 7 4 7H4.57143C4.93962 7 5.23809 6.70152 5.23809 6.33333V4.2H8.38095C8.74914 4.2 9.04762 3.90152 9.04762 3.53333V3C9.04762 2.63181 8.74914 2.33333 8.38095 2.33333H5.23809V0H3.33333V2.33333H0Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.8H3.80952V2.33333V0H4.7619V2.33333V2.8H8.57143V3.73333H4.7619V4.2V6.53333H3.80952V4.2V3.73333H0V2.8Z'
					fill='#DB1E36'
				/>
			</g>
		</svg>
	);
};

export default BritishVirginIslandsFlagIcon;
